import React, { useEffect } from "react"

import { generateDocumentTitle } from "../../../constants/document-title.ts"
import { LeadLifecycleSettings } from "../components/lead-lifecycle/LeadLifecycleSettings.tsx"

export default function SettingsLeadLifecyclePage() {
  useEffect(() => {
    generateDocumentTitle("Settings Lead Life Cycle")
  }, [])

  return <LeadLifecycleSettings />
}
